import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47014636"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["Tabs", _ctx.computedClasses])
  }, [
    (_ctx.isLink)
      ? (_openBlock(), _createElementBlock("nav", {
          key: 0,
          class: _normalizeClass(['Tabs__content', { isSubTab: _ctx.isSubTab, isNew: _ctx.isNew }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              class: _normalizeClass(["Tabs__tab", { disabled: _ctx.disabled }]),
              key: tab.id,
              to: tab.path
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(tab.name), 1)
              ]),
              _: 2
            }, 1032, ["class", "to"]))
          }), 128))
        ], 2))
      : (_openBlock(), _createElementBlock("nav", {
          key: 1,
          class: _normalizeClass(['Tabs__content', { isSubTab: _ctx.isSubTab, isNew: _ctx.isNew }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createElementBlock("span", {
              class: _normalizeClass(["Tabs__tab", { disabled: _ctx.disabled, isActive: tab.id === _ctx.state.current_id }]),
              key: tab.id,
              onClick: ($event: any) => (_ctx.emitClick(tab.id))
            }, _toDisplayString(tab.name), 11, _hoisted_1))
          }), 128))
        ], 2))
  ], 2))
}